import * as z from "zod";

export const deliveryPerformanceMetrics = z.object({
  avgOrderToDeliveryDays: z.number().nullable(),
  avgProcessingDays: z.number().nullable(),
  avgPickupDays: z.number().nullable(),
  avgTransitDays: z.number().nullable(),
  deliveredCount: z.number(),
});

export const deliveryPerformanceTimeSeriesPoint = z.object({
  period: z.string(),
  avgOrderToDeliveryDays: z.number().nullable(),
  avgProcessingDays: z.number().nullable(),
  avgPickupDays: z.number().nullable(),
  avgTransitDays: z.number().nullable(),
  deliveredCount: z.number(),
});

export const deliveryPerformanceDistributionBucket = z.object({
  bucketDays: z.number(),
  count: z.number(),
  comparisonCount: z.number().nullable(),
});

export const deliveryPerformanceByCarrier = z.object({
  carrier: z.string(),
  deliveredCount: z.number(),
  avgOrderToDeliveryDays: z.number().nullable(),
  avgProcessingDays: z.number().nullable(),
  avgPickupDays: z.number().nullable(),
  avgTransitDays: z.number().nullable(),
  p50TransitDays: z.number().nullable(),
  p85TransitDays: z.number().nullable(),
  p95TransitDays: z.number().nullable(),
});

export const deliveryPerformanceByDestination = z.object({
  destination: z.string(),
  deliveredCount: z.number(),
  avgOrderToDeliveryDays: z.number().nullable(),
  avgProcessingDays: z.number().nullable(),
  avgPickupDays: z.number().nullable(),
  avgTransitDays: z.number().nullable(),
});

export const deliveryPerformanceFilterInput = z.object({
  startDate: z.date(),
  endDate: z.date(),
  carriers: z.array(z.string()).optional(),
  carrierServices: z.array(z.string()).optional(),
  destinationCountries: z.array(z.string()).optional(),
  destinationStates: z.array(z.string()).optional(),
});

export type DeliveryPerformanceMetrics = z.infer<
  typeof deliveryPerformanceMetrics
>;
export type DeliveryPerformanceTimeSeriesPoint = z.infer<
  typeof deliveryPerformanceTimeSeriesPoint
>;
export type DeliveryPerformanceDistributionBucket = z.infer<
  typeof deliveryPerformanceDistributionBucket
>;
export type DeliveryPerformanceByCarrier = z.infer<
  typeof deliveryPerformanceByCarrier
>;
export type DeliveryPerformanceByDestination = z.infer<
  typeof deliveryPerformanceByDestination
>;
